// Day/Night toggle: System -> Light -> Dark -> System. Persisted in localStorage 'labels.theme'.
// index.html applies the saved value before first paint; this module keeps it in sync afterwards.
import { $ } from './dom.js';

const KEY = 'labels.theme';
const ORDER = ['system', 'light', 'dark'];
const NAMES = { system: 'System', light: 'Light', dark: 'Dark' };
const media = window.matchMedia ? window.matchMedia('(prefers-color-scheme: light)') : null;

export function getTheme() {
  let t = null;
  try {
    t = localStorage.getItem(KEY);
  } catch {
    /* ignore */
  }
  return t === 'light' || t === 'dark' ? t : 'system';
}

/** The theme actually in effect ('light' | 'dark'). */
export function effectiveTheme() {
  const t = getTheme();
  if (t !== 'system') return t;
  return media && media.matches ? 'light' : 'dark';
}

export function setTheme(t) {
  if (!ORDER.includes(t)) t = 'system';
  try {
    if (t === 'system') localStorage.removeItem(KEY);
    else localStorage.setItem(KEY, t);
  } catch {
    /* ignore */
  }
  apply();
}

export function cycleTheme() {
  const next = ORDER[(ORDER.indexOf(getTheme()) + 1) % ORDER.length];
  setTheme(next);
  return next;
}

function apply() {
  const t = getTheme();
  if (t === 'system') delete document.documentElement.dataset.theme;
  else document.documentElement.dataset.theme = t;
  const eff = effectiveTheme();
  const meta = document.querySelector('meta[name="theme-color"]');
  if (meta) meta.setAttribute('content', eff === 'light' ? '#ffffff' : '#0a0b0d');
  const btn = $('#btn-theme');
  if (btn) {
    const label = t === 'system' ? `Theme: System (${NAMES[eff].toLowerCase()})` : `Theme: ${NAMES[t]}`;
    btn.title = `${label} — click for ${NAMES[ORDER[(ORDER.indexOf(t) + 1) % ORDER.length]]}`;
    btn.setAttribute('aria-label', `${label}. Click to switch theme`);
    btn.dataset.mode = t;
  }
}

export function initTheme() {
  apply();
  const btn = $('#btn-theme');
  if (btn) btn.addEventListener('click', () => cycleTheme());
  if (media && media.addEventListener) media.addEventListener('change', apply);
}
